import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityLevalloisPerretPage() {
  const data = citiesData.find((c) => c.slug === "levallois-perret")!;
  return <CityPage data={data} />;
}
